import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-involuntary-regulations',
  templateUrl: './involuntary-regulations.component.html',
  styleUrls: ['./involuntary-regulations.component.css']
})
export class InvoluntaryRegulationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
